import { render } from "./TooltipMessage.vue?vue&type=template&id=65028ffa"
import script from "./TooltipMessage.vue?vue&type=script&lang=js"
export * from "./TooltipMessage.vue?vue&type=script&lang=js"

import "./TooltipMessage.vue?vue&type=style&index=0&id=65028ffa&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__